/*!
 * Copyright (c) Microsoft Corporation.
 * All rights reserved. See LICENSE in the project root for license information.
 */

import * as Msdyn365 from '@msdyn365-commerce/core';
import { getCustomerAddressAsync } from './SearchItemsDataActionExtension.g';
import { IITSCustomerAddressResponse } from './SearchItemsDataServiceEntities.g';

/**
 * Getaddresses Input Action
 */

export interface IITSCutomerAddressInput extends Msdyn365.IActionInput {
    customerAccount: string;
}
export class GetaddressesInput implements Msdyn365.IActionInput {
    public customerAccount: string;
    // TODO: Construct the input needed to run the action
    constructor(customerAccount: string) {
        this.customerAccount = customerAccount;
    }

    // TODO: Determine if the results of this get action should cache the results and if so provide
    // a cache object type and an appropriate cache key
    public getCacheKey = () => `GetCustomerAddress`;
    public getCacheObjectType = () => 'GetCustomerAddress';
    public dataCacheType = (): Msdyn365.CacheType => 'none';
}

/**
 * TODO: Use this function to call your action and process the results as needed
 */
export async function getCustomerAddressesAction(
    request: IITSCutomerAddressInput,
    ctx: Msdyn365.IActionContext
): Promise<IITSCustomerAddressResponse | null> {
    if (request.customerAccount) {
        try {
            const result = await getCustomerAddressAsync({ callerContext: ctx }, request.customerAccount);
            if (result) {
                return result;
            }
        } catch (error) {
            console.log('Error', error);
        }
    }
    return null;
}

export default Msdyn365.createObservableDataAction({
    action: <Msdyn365.IAction<IITSCustomerAddressResponse | null>>getCustomerAddressesAction,
    // TODO: Give your data action a unique id
    id: `GetCustomerAddress`
    // input: createInput
    // TODO: Uncomment the below line if this is a meant to be a batched data action
    // isBatched: true
});
